(ns basic-components.tooltip
  (:require
   [frontend.bootstrap.components :as rbs]
   [reagent.core :as r]))


(defn view
  ([tooltip-text hiccup]
   (view tooltip-text hiccup nil))
  ([tooltip-text hiccup options]
   [rbs/OverlayTrigger
    (merge
     {:placement     "top"
      :popper-config {:modifiers [{:name    "preventOverflow"
                                   :options {:main-axis false}}
                                  {:name "hide"}]}
      :overlay       (r/as-element [rbs/Tooltip
                                    {:class "in"
                                     :id    (str "tooltip-" tooltip-text)}
                                    tooltip-text])}
     options)
    hiccup]))
